<template>
	<GridContextMenuMobile
		:is-open="isOpen"
		:menu-items="menuItems"
		:context-data="eventTags"
		:blocking="false"
		@item-click="(id, action, data) => $emit('item-click', id, action, data)"
		@close="$emit('close')"
	>
		<template #header>
			<div class="title">
				<span class="selected-counter">
					{{ selectedCounterLabel }}
				</span>
				<span class="event-type">
					{{ selectedClipsLabel }}
				</span>
			</div>
		</template>
	</GridContextMenuMobile>
</template>

<script>
import GridContextMenuMobile from './GridContextMenuMobile';

export default {
	name:       'EventTagBulkContextMenuMobile',
	components: { GridContextMenuMobile },
	props:      {
		isOpen: {
			type:    Boolean,
			default: false,
		},
		menuItems: {
			type:    Array,
			default: () => [],
		},
		eventTags: {
			type:     Array,
			required: true,
		},
		total: {
			type:    Number,
			default: 0,
		},
	},
	computed: {
		selectedCounterLabel() {
			return this.isAllSelected
				? this.transUcfirst('commons.all')
				: this.eventTags.length;
		},
		selectedClipsLabel() {
			return this.transUcfirst('one.action_selected');
		},
		isAllSelected() {
			return this.eventTags.length === this.total;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.title {
	@include text-sm-2;

	.selected-counter {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		width: 44px;
		padding-top: 2px;
		margin-right: 8px;
		background: var(--color-hype-yellow);
		color: var(--color-shadow-grey);
		border-radius: 24px;
	}
}
</style>
